export default __webpack_public_path__ + "static/media/formLevelErrorsIcon.02cb7a82.svg";